import axios from 'axios';
import config from '../config';

const requestPasswordReset = async data => {
  const res = await axios.post(`${config.API_URL}/api/accounts/request-password-reset/`, data);
  return res;
};

export default requestPasswordReset;
